import React, { useEffect, useState } from "react";
import {
ArrowRight,
Activity,
ShieldCheck,
CalendarDays,
RadioTower,
MapPin,
Mail,
Menu,
X,
CheckCircle2,
ChevronRight,

} from "lucide-react";

import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Tooltip,
  Typography,
  Button
} from "@mui/material";
  import LogoutIcon from "@mui/icons-material/Logout";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import XIcon from "@mui/icons-material/X";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { create } from "../Store/projectPermission/permssionReducer";



import { baseURL } from "../Config/config";
import selexModeler from "../images/products/selexmodeler.png";
import selexmbplus from "../images/products/selexmbplus.png";

import selexSep from "../images/products/selexsep.jpg";
import selexMsd from "../images/products/selexmsd.jpg";
import selexCam from "../images/products/selexcam.png";
import selexCip from "../images/products/selexcip.png";
import selexSws from "../images/products/selexsws.jpg";
import selexicarus from "../images/products/selexicarus.jpg";
import selexhazop from "../images/products/selexhazop.png";
import selexreliability from "../images/products/selexreliability.png";
import selexeca from "../images/products/selexeca.png";
import selexaim from "../images/products/selexaim.png";
import selexstudio from "../images/products/selexstudio.png";
import selexleak from "../images/products/selexleak.png";
import selexad from "../images/products/selexad.jpg";
import selexpulse from "../images/products/selexpulse.png";
import selexwell from "../images/products/selexwell.png";
import selexpyramis from "../images/products/selexpyramis.png";

import selexrs from "../images/products/selexrs.jpg";
import selexdsm from "../images/products/selexdsm.png";
import selexole from "../images/products/selexole.jpg";
import selexdmx from "../images/products/selexdmx.jpg";
import selexfz from "../images/products/selexfz.png";
import selexlng from "../images/products/selexlng.jpg";

import selexsru from "../images/products/selexsru.png";

import selexlab from "../images/products/selexlab.jpg";

import selexheater from "../images/products/selexheater.jpg";

import selexref from "../images/products/selexref.png";

import selexp360 from "../images/products/selexp360.png";

import selexmppl from "../images/products/selexmppl.png";

import selexrxn from "../images/products/selexrxn.png";
import selexmsa from "../images/products/selexmsa.png";
import selexnode from "../images/products/selexnode.png";
import selexvf from "../images/products/selexvf.png";
import selexflare from "../images/products/selexflare.png";






















const COLORS = {
  primary: "#0078c9",
  accent: "#9e0b22",
  navy: "#062a4f",
  dark: "#071827",
  muted: "#64748b",
};

const navLinks = [
  { label: "Home", href: "#hero" },
  { label: "About", href: "#about" },
  { label: "Solutions", href: "#solutions" },
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Blog", href: "#blog" },
  { label: "Contact", href: "#contact" },
];

const productLogos = [
  { label: "SelexMB Plus", href: selexmbplus },
  { label: "SelexMB Explorer", href: selexmbplus },
   { label: "SelexStudio", href: selexstudio },
  { label: "SelexModeler", href: selexModeler },
  { label: "SelexWELL", href: selexwell },
  { label: "SelexSEP", href: selexSep },
  { label: "SelexAdsorption", href: selexad },
  { label: "SelexMSD", href: selexMsd },
  { label: "SelexCAM", href: selexCam },
  { label: "SelexCIP", href: selexCip },
  { label: "SelexICARUS", href: selexicarus },
  { label: "SelexSWS", href: selexSws },
  { label: "SelexRS", href: selexrs },
  { label: "SelexDSM", href: selexdsm },
  { label: "SelexOLE", href: selexole },
  { label: "SelexDMX", href: selexdmx },
{ label: "SelexFZ", href: selexfz },
{ label: "SelexLNG", href: selexlng },
{ label: "SelexSRU", href: selexsru },
{ label: "SelexLAB", href: selexlab },
{ label: "SelexHeater", href: selexheater },
{ label: "SelexRef", href: selexref },
{ label: "SelexP360", href: selexp360 },
{ label: "SelexMPPL", href: selexmppl },
{ label: "SelexRXN", href: selexrxn },
{ label: "SelexMSA", href: selexmsa },
{ label: "SelexNode", href: selexnode },
{ label: "SelexPulse", href: selexpulse },
   { label: "SelexPyramis", href: selexpyramis },
    { label: "SelexReliability", href: selexreliability },
     { label: "SelexECA", href: selexeca },
      { label: "SelexAIM", href: selexaim }, 
      { label: "SelexLeak", href: selexleak },
      { label: "SelexVF", href: selexvf },
      { label: "SelexFlare", href: selexflare },


];

const solutions = [
  {
    number: "01",
    pagename:"/selexmblanding",
    title: "SelexMB™",
    image: "images/LandingPage/selexmb.jpg",
    logo: "images/LandingPage/SelexMB Final.png",
    description:
      "AI + first-principles engine that builds soft sensors, forecasts process behavior, dynamically optimize the operations capturing the complex phenomena to support faster, data-driven operational and engineering decisions.​",
  },
  {
    number: "02",
    pagename:"/selexsimlanding",
    title: "SelexSIM™",
    image: "images/LandingPage/selexsim.webp",
    logo: "images/LandingPage/SelexSIM.png",
    description:
      "High-fidelity dynamic simulation and optimization platform connecting subsurface, surface, and facilities to maximize throughput, recovery, energy efficiency, and asset life in real time.​",
  },
  {
    number: "03",
    pagename:"/selectselexrisk",
    title: "SelexRISK™",
    image: "images/LandingPage/selexrisk.jpg",
    logo: "images/LandingPage/SelexRISK.png",
    description:
      "AI-powered condition-based management that predicts Probability of Failure months ahead, enabling proactive maintenance, safer operation, higher uptime, and reduced financial risk.​",
  },
];

const services = [
  {
    icon: Activity,
    title: "Engineering Services",
    description:
      "Integrated engineering and machine-learning solutions tailored for complex energy-sector operations.",
  },
  {
    icon: ShieldCheck,
    title: "Process Safety & HSE",
    description:
      "Consulting services that reduce release-event likelihood, improve compliance, and strengthen HSE performance.",
  },
  {
    icon: CalendarDays,
    title: "Project Management",
    description:
      "Structured project controls that bring engineering, cost, quality, and delivery schedules into one aligned workflow.",
  },
  {
    icon: RadioTower,
    title: "Facilities Management",
    description:
      "Asset integrity, performance, maintenance, and operational optimization strategies for long-term reliability.",
  },
];

const fallbackProjects = [
  {
    title: "Digital Asset Optimization",
    author: "OptimizeXP Team",
    date: "2026",
    image: "images/LandingPage/selexsim.webp",
    slug: "digital-asset-optimization",
  },
  {
    title: "AI-Enabled Maintenance Intelligence",
    author: "OptimizeXP Team",
    date: "2026",
    image: "images/LandingPage/selexmb.jpg",
    slug: "ai-maintenance-intelligence",
  },
  {
    title: "Process Safety Risk Dashboard",
    author: "OptimizeXP Team",
    date: "2026",
    image: "images/LandingPage/selexrisk.jpg",
    slug: "process-safety-risk-dashboard",
  },
];

const fallbackBlogs = [
  {
    title: "How AI Is Transforming Energy Operations",
    author: "OptimizeXP Team",
    date: "2026",
    image: "images/LandingPage/hero-img.png",
    slug: "ai-transforming-energy-operations",
  },
  {
    title: "Why Simulation Quality Matters in Engineering",
    author: "OptimizeXP Team",
    date: "2026",
    image: "images/LandingPage/selexsim.webp",
    slug: "simulation-quality-engineering",
  },
  {
    title: "Modern Risk Management for Process Industries",
    author: "OptimizeXP Team",
    date: "2026",
    image: "images/LandingPage/selexrisk.jpg",
    slug: "modern-risk-management",
  },
];

function SectionTitle({ eyebrow, title, description }) {
  return (
    <div className="section-title">
      {eyebrow && <span>{eyebrow}</span>}
      <h2>{title}</h2>
      {description && <p>{description}</p>}
    </div>
  );
}

function Header({isLoggedIn,setIsLoggedIn}) {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);
  const navigate = useNavigate();
    const dispatch = useDispatch();
   function logout() {
      sessionStorage.removeItem("usertoken");
      sessionStorage.removeItem("projectID");
      sessionStorage.removeItem("projectName");
      setIsLoggedIn(false);

  
      dispatch(create([{ empty: true }]));
  
      navigate("/");      
    }

  return (
    <header className="site-header">
      <a href="#hero" className="brand" onClick={closeMenu}>
        <img src="images/LandingPage/logo.png" alt="SelexSuite™" />
      </a>

      <nav className={open ? "nav-links open" : "nav-links"}>
        {navLinks.map((link) => (
          <a key={link.href} href={link.href} onClick={closeMenu}>
            {link.label}
          </a>
        ))}
      </nav>

       {isLoggedIn ? (
                 <Tooltip title={<Typography fontSize={14}>Logout</Typography>}>
  <Box
    onClick={logout}
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      cursor: "pointer",
      px: 2,
      py: 1,
      borderRadius: "14px",
      background: "rgba(0,120,201,0.08)",
      color: "#0078c9",
      transition: "0.3s",
      "&:hover": {
        background: "#9e0b22",
        color: "#fff",
        transform: "translateY(-2px)",
      },
    }}
  >
    <LogoutIcon sx={{ fontSize: 23 }} />
    <Typography
      sx={{
        fontSize: "13px",
        fontWeight: 700,
        letterSpacing: "0.5px",
      }}
    >
      Logout
    </Typography>
  </Box>
</Tooltip>
                    ):(

      <div className="header-actions">
        <a className="primary-btn small" href="/login"   rel="noreferrer">
          Get Started
        </a>
        <button className="menu-btn" onClick={() => setOpen((prev) => !prev)} aria-label="Toggle menu">
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
                  )}
    </header>
  );
}

function Hero() {
  return (
    <section id="hero" className="hero-section">
      <div className="hero-bg-orb orb-one" />
      <div className="hero-bg-orb orb-two" />

      <div className="hero-content">
        <div className="hero-copy">
          <div className="pill">AI • Engineering • Risk Management</div>
          <h1>Smarter engineering solutions for modern energy businesses.</h1>
          <p>
            SelexSuite™ is an integrated AI and physics-based platform that transforms industrial operations from reactive to predictive by combining performance intelligence, dynamic optimization, and risk foresight.​
          </p>
          <div className="hero-buttons">
            <a className="primary-btn" href="/login"   rel="noreferrer">
              Get Started <ArrowRight size={18} />
            </a>
            <a className="secondary-btn" href="#solutions">
              Explore Solutions
            </a>
          </div>
        </div>

        <div className="hero-visual">
          <div className="hero-card floating-card top-card">
            <span>Operational Intelligence</span>
            <strong>AI Powered</strong>
          </div>
          <img src="images/LandingPage/hero-img.png" alt="Engineering software dashboard" />
          <div className="hero-card floating-card bottom-card">
            <span>Risk Visibility</span>
            <strong>Real-Time Decisions</strong>
          </div>
        </div>
      </div>
    </section>
  );
}

function Products() {
  return (
    <section className="products-section">
      <SectionTitle eyebrow="Product Suite" title="Our Products" />
      <div className="logo-marquee">
  <div className="logo-track">
    {[...productLogos, ...productLogos].map((each, index) => (
      <div className="logo-card" key={`${each.href}-${index}`}>
        <img src={each.href} alt={each.label} />

        <span
          style={{
            color: "#062a4f",
            fontSize: "16px",
            fontWeight: 700,
            marginTop: "2px",
          }}
        >
          {each.label}
        </span>
      </div>
    ))}
  </div>
</div>
    </section>
  );
}

function About() {
  return (
    <section id="about" className="about-section section-pad">
      <SectionTitle eyebrow="About Us" title="Built for high-performance engineering teams" />
      <div className="about-grid">
        <div className="about-panel highlight-panel">
          <h3>OptimizeXP aims to be the most competitive and productive engineering consultant in the world.</h3>
          <p>
            Our core competencies in engineering, project management, consulting, and training are continuously improved to deliver best-in-class outcomes.
          </p>
        </div>
        <div className="about-panel">
          <ul className="check-list">
            <li><CheckCircle2 /> Committed, empowered, and innovative people.</li>
            <li><CheckCircle2 /> Industry leadership in health, safety, and environmental performance.</li>
            <li><CheckCircle2 /> Partner in sustained social and operational progress.</li>
          </ul>
          <p>
            We provide a wide spectrum of consulting and advisory services, deep technical expertise, asset management, engineering, procurement, construction capability, and integrated solutions.
          </p>
          <a className="text-link" href="/aboutpage">Read More <ArrowRight size={16} /></a>
        </div>
      </div>
    </section>
  );
}

function Solutions() {
  return (
    <section id="solutions" className="solutions-section section-pad">
      <SectionTitle eyebrow="Solutions" title="Software built for safer and smarter operations" />
      <div className="cards-grid three">
        {solutions.map((solution) => (
          <a className="solution-card" href={solution.pagename}   rel="noreferrer" key={solution.title}>
            <div className="solution-image">
              <img src={solution.image} alt={solution.title} />
              <span>{solution.number}</span>
            </div>
            <div className="solution-body">
              <img className="solution-logo" src={solution.logo} alt={`${solution.title} logo`} />
              <h3>{solution.title}</h3>
              <p>{solution.description}</p>
              <div className="card-link" >View solution <ArrowRight size={16} /></div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}

function Services() {
  return (
    <section id="services" className="services-section section-pad tinted-section">
      <SectionTitle
        eyebrow="Services"
        title="Consulting services that improve stability and margins"
        description="OptimizeXP helps companies reduce operational risk, improve process reliability, and increase profit margins through engineering-led digital transformation."
      />
      <div className="cards-grid four">
        {services.map(({ icon: Icon, title, description }) => (
          <div className="service-card" key={title}>
            <div className="service-icon"><Icon size={26} /></div>
            <h3>{title}</h3>
            <p>{description}</p>
          </div>
        ))}
      </div>
       <section id="about" className="about-section section-pad2">
      <div className="about-grid">
        <div className="about-panel highlight-panel">
          <h3>AI Solutions & Services</h3>
          <p>
            OptimizeXP combines machine-learning operations, neural networks, and deep process domain knowledge to deliver software that runs on real units — across oil, gas, and refining operations.
          </p>
          <p>Every solution is delivered as a self-contained application — no installation, no dependency you don't control. Three product families cover the plant end to end.

</p>
        </div>
        <div className="about-panel">
          <ul className="check-list">
            <li><CheckCircle2 /> Machine & Asset Data</li>
            <li><CheckCircle2 /> Model, Simulate & Optimize</li>
            <li><CheckCircle2 /> Process Safety & Risk</li>
          </ul>
          <p style={{color:"black",fontWeight:"bold"}}>
            We provide a wide spectrum of consulting and advisory services, deep technical expertise, asset management, engineering, procurement, construction capability, and integrated solutions.
          </p>
          <a className="text-link" href="/optimizexp2">Read More <ArrowRight size={16} /></a>
        </div> 
      </div>
    </section>
    </section>
    
  );
}

function PostCard({ item, type }) {
  return (
    <article className="post-card">
      <div className="post-image">
        <img src={item.image} alt={item.title} />
      </div>
      <div className="post-body">
        <h3>{item.title}</h3>
        <p>By {item.author || "OptimizeXP Team"}</p>
        <a href={`/${type}/${item.slug}`}>
          Read More <ArrowRight size={16} />
        </a>
      </div>
    </article>
  );
}

function ProjectsAndBlogs() {
  const [projects, setProjects] = useState(fallbackProjects);
  const [blogs, setBlogs] = useState(fallbackBlogs);

  useEffect(() => {
    let mounted = true;

    async function loadData() {
      try {
        const blogRes = await fetch(`${baseURL}/getallblogs`);
        const blogData = await blogRes.json();
        if (mounted && blogData?.code && Array.isArray(blogData.data)) {
          setBlogs(blogData.data.slice(0, 3));
        }
      } catch (error) {
        console.log("Blog API unavailable. Showing fallback blogs.", error);
      }

      try {
        const projectRes = await fetch(`${baseURL}/getallprojects`);
        const projectData = await projectRes.json();
        if (mounted && projectData?.code && Array.isArray(projectData.data)) {
          setProjects(projectData.data.slice(0, 3));
        }
      } catch (error) {
        console.log("Project API unavailable. Showing fallback projects.", error);
      }
    }

    loadData();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      <section id="projects" className="section-pad">
        <SectionTitle eyebrow="Projects" title="Recent project highlights" />
        <div className="cards-grid three">
          {projects.map((project) => <PostCard key={project.slug || project.title} item={project} type="projects" />)}
        </div>
        <div className="section-action"><a className="outline-btn" href="/allprojects">See All Projects <ArrowRight size={16} /></a></div>
      </section>

      <section id="blog" className="section-pad tinted-section">
        <SectionTitle eyebrow="Insights" title="Recent blog posts" />
        <div className="cards-grid three">
          {blogs.map((blog) => <PostCard key={blog.slug || blog.title} item={blog} type="blog" />)}
        </div>
        <div className="section-action"><a className="outline-btn" href="/blogs">Read All Blogs <ArrowRight size={16} /></a></div>
      </section>
    </>
  );
}

function Contact() {
  return (
    <section id="contact" className="contact-section section-pad">
      <SectionTitle eyebrow="Contact" title="Let’s build smarter operations together" />
      <div className="contact-card">
        <div>
          <h3>SelexSuite™</h3>
          <p>
            An integrated AI and physics-based platform that transforms industrial operations from reactive to predictive by combining performance intelligence, dynamic optimization, and risk foresight.​
             </p>
        </div>
        <div className="contact-list">
          <div><MapPin /> <span>85 Great Portland st. First Floor W1W7LT London, United Kingdom</span>
          <hr/>
          <span>Abu Dhabi, Khalifa Bin Zayed the 1st Street.WTC Building</span>
          
          </div>
          <div><LinkedInIcon /> <a href="https://www.linkedin.com/company/optimize-hydrocarbon-energey"   rel="noreferrer">Optimize-Hydrocarbon-Energey</a></div>
          <div><Mail /> <a href="mailto:business@optimizegs.com">business@optimizegs.com</a></div>
        </div>
      </div>
    </section>
  );
}

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-grid">
        <div>
          <img src="../images/LandingPage/logo.png" alt="Optimizegs" className="footer-logo" />
          <p>85 Great Portland st. First Floor W1W7LT London, United Kingdom</p>
          <p>Abu Dhabi, Khalifa Bin Zayed the 1st Street.WTC Building </p>
          <p><strong>Email:</strong> business@optimizegs.com</p>
        </div>
        <div>
          <h4>Useful Links</h4>
          {navLinks.slice(0, 5).map((link) => <a key={link.href} href={link.href}><ChevronRight size={14} /> {link.label}</a>)}
        </div>
        <div>
          <h4>Our Services</h4>
          {services.map((service) => <a key={service.title} href="#services"><ChevronRight size={14} /> {service.title}</a>)}
        </div>
        <div>
          <h4>Follow Us</h4>
          <div className="social-links">
           
            <a href="https://www.linkedin.com/company/optimize-hydrocarbon-energey"   rel="noreferrer"><LinkedInIcon /></a>
          </div>
        </div>
      </div>
      <div className="copyright">© Copyright <strong>OptimizeXP</strong>. All Rights Reserved</div>
    </footer>
  );
}


export default function LandingPageNew2(props) {
  const [isLoggedIn, setIsLoggedIn] = useState(
  !!sessionStorage.getItem("usertoken")
);
  
  return (
    <div className="modern-company-page">
      <style>{styles}</style>
      <Header  isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />
      <main>
        <Hero />
        <Products />
        <About />
        <Solutions />
        <Services />
        <ProjectsAndBlogs />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

  .modern-company-page {
    --primary: ${COLORS.primary};
    --accent: ${COLORS.accent};
    --navy: ${COLORS.navy};
    --dark: ${COLORS.dark};
    --muted: ${COLORS.muted};
    font-family: 'Inter', sans-serif;
    color: var(--dark);
    background: #ffffff;
    overflow-x: hidden;
  }

  .site-header {
    position: fixed;
    top: 0px;
    left: 50%;
    transform: translateX(-50%);
    width: min(1180px, calc(100% - 32px));
    min-height: 74px;
    padding: 10px 14px 10px 22px;
    border-radius: 24px;
    background: #fff;
    backdrop-filter: blur(18px);
    box-shadow: 0 18px 50px rgba(8, 37, 68, 0.14);
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 1000;
  }

  .brand img { width: 150px; height: 58px; object-fit: contain; display: block; }

  .nav-links { display: flex; gap: 6px; align-items: center; }
  .nav-links a {
    text-decoration: none;
    color: #17324d;
    font-size: 14px;
    font-weight: 700;
    padding: 10px 12px;
    border-radius: 999px;
    transition: 0.25s ease;
  }
  .nav-links a:hover { background: rgba(0,120,201,0.10); color: var(--primary); }

  .header-actions { display: flex; align-items: center; gap: 10px; }
  .menu-btn {
    display: none;
    border: 0;
    border-radius: 14px;
    width: 44px;
    height: 44px;
    background: rgba(0,120,201,0.10);
    color: var(--primary);
    cursor: pointer;
  }

  .primary-btn, .secondary-btn, .outline-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border-radius: 999px;
    font-size: 14px;
    font-weight: 800;
    text-decoration: none;
    transition: 0.25s ease;
  }

  .primary-btn {
    color: white;
    background: linear-gradient(135deg, var(--primary), #005da0);
    padding: 14px 22px;
    box-shadow: 0 14px 30px rgba(0,120,201,0.30);
  }
  .primary-btn:hover {color:white;background:#9e0b22; transform: translateY(-2px); box-shadow: 0 18px 40px rgba(0,120,201,0.38); }
  .primary-btn.small { padding: 12px 18px; }

  .secondary-btn, .outline-btn {
    color: var(--primary);
    border: 1px solid rgba(0,120,201,0.28);
    background: white;
    padding: 13px 20px;
  }
  .secondary-btn:hover, .outline-btn:hover { border-color: var(--accent); color: var(--accent); transform: translateY(-2px); }

  .hero-section {
    min-height: 100vh;
    padding: 150px 24px 90px;
    background:
      radial-gradient(circle at 12% 18%, rgba(0,120,201,0.18), transparent 34%),
      radial-gradient(circle at 90% 24%, rgba(158,11,34,0.14), transparent 28%),
      linear-gradient(135deg, #061d34 0%, #082f56 52%, #04121f 100%);
    position: relative;
    overflow: hidden;
  }

  .hero-content {
    width: min(1180px, 100%);
    margin: auto;
    display: grid;
    grid-template-columns: 1.02fr 0.98fr;
    gap: 56px;
    align-items: center;
    position: relative;
    z-index: 2;
  }

  .pill {
    width: fit-content;
    color: white;
    background: rgba(255,255,255,0.12);
    border: 1px solid rgba(255,255,255,0.18);
    padding: 9px 14px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 800;
    margin-bottom: 22px;
  }

  .hero-copy h1 {
    color: white;
    font-size: clamp(42px, 6vw, 76px);
    line-height: 0.96;
    letter-spacing: -3px;
    margin: 0 0 22px;
  }
  .hero-copy p {
    color: rgba(255,255,255,0.78);
    font-size: 18px;
    line-height: 1.8;
    max-width: 620px;
    margin: 0 0 32px;
  }
  .hero-buttons { display: flex; gap: 14px; flex-wrap: wrap; }

  .hero-visual { position: relative; }
  .hero-visual img {
    width: 650px;
    min-height: 430px;
    object-fit: cover;
    border-radius: 34px;
    border: 4px solid rgba(158,11,34,0.75);
    box-shadow: 0 32px 90px rgba(0,0,0,0.38);
  }
  .hero-card {
    position: absolute;
    z-index: 3;
    background: rgba(255,255,255,0.92);
    border: 1px solid rgba(255,255,255,0.35);
    box-shadow: 0 18px 48px rgba(0,0,0,0.20);
    border-radius: 20px;
    padding: 16px 18px;
    min-width: 190px;
  }
  .hero-card span { color: var(--muted); font-size: 12px; font-weight: 700; display: block; margin-bottom: 5px; }
  .hero-card strong { color: var(--navy); font-size: 17px; }
  .top-card {
  top: -42px;
  left: -80px;
}

.bottom-card {
  right: -70px;
  bottom: -35px;
}

  .products-section, .section-pad { padding: 86px 24px; }
   .section-pad2 { padding: 54px 20px; }
  .tinted-section { background: linear-gradient(180deg, #f7fbff, #ffffff); }

  .section-title { text-align: center; width: min(780px, 100%); margin: 0 auto 44px; }
  .section-title span {
    color: var(--accent);
    background: rgba(158,11,34,0.08);
    padding: 7px 13px;
    border-radius: 999px;
    font-size: 12px;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: 1px;
  }
  .section-title h2 {
    font-size: clamp(30px, 4vw, 48px);
    color: var(--navy);
    letter-spacing: -1.6px;
    margin: 14px 0 12px;
  }
  .section-title p { color: var(--muted); line-height: 1.8; margin: 0; }

  .logo-marquee {
    width: min(1180px, 100%);
    margin: auto;
    overflow: hidden;
    mask-image: linear-gradient(to right, transparent, black 12%, black 88%, transparent);
  }
  .logo-track { display: flex; gap: 22px; width: max-content; animation: marquee 24s linear infinite; }
  .logo-card {
    width: 155px;
    height: 92px;
    display: grid;
    place-items: center;
    background: white;
    border-radius: 22px;
    border: 1px solid rgba(0,120,201,0.10);
    box-shadow: 0 12px 34px rgba(8,37,68,0.08);
  }
  .logo-card img { max-width: 112px; max-height: 68px; object-fit: contain; filter: saturate(1.05);margin-bottom:"3px" }
  @keyframes marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }

  .about-grid, .cards-grid, .contact-card, .footer-grid {

    width: min(1180px, 100%);
    margin: auto;
  }
    
  .about-grid { display: grid; grid-template-columns: 0.95fr 1.05fr; gap: 24px; }
  .about-panel {
    background: white;
    border: 1px solid rgba(0,120,201,0.12);
    border-radius: 30px;
    padding: 34px;
    box-shadow: 0 18px 48px rgba(8,37,68,0.08);
  }
    .about-panel h3 {
    color: white;
  }
  .highlight-panel { background: linear-gradient(135deg, var(--primary), #064b7f); color: white; }
  .highlight-panel h3 { font-size: 30px; line-height: 1.22; margin: 0 0 18px; }
  .highlight-panel p { color: rgba(255,255,255,0.82); }
  .about-panel p { line-height: 1.85; color: #fff; }

  .check-list { list-style: none; padding: 0; margin: 0 0 22px; display: grid; gap: 14px; }
  .check-list li { display: flex; align-items: flex-start; gap: 10px; color: #17324d; font-weight: 700; line-height: 1.55; }
  .check-list svg { color: var(--accent); min-width: 20px; margin-top: 2px; }
  .text-link, .post-body a, .card-link {
    color: var(--primary);
    text-decoration: none;
    font-weight: 900;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .cards-grid { display: grid; gap: 24px; }
  .cards-grid.three { grid-template-columns: repeat(3, 1fr); }
  .cards-grid.four { grid-template-columns: repeat(4, 1fr); }

  .solution-card, .service-card, .post-card {
    background: white;
    border: 1px solid rgba(0,120,201,0.12);
    border-radius: 30px;
    overflow: hidden;
    box-shadow: 0 18px 48px rgba(8,37,68,0.08);
    transition: 0.25s ease;
  }
  .solution-card { text-decoration: none; color: inherit; }
  .solution-card:hover, .service-card:hover, .post-card:hover { transform: translateY(-8px); box-shadow: 0 26px 70px rgba(8,37,68,0.14); }
  .solution-image, .post-image { position: relative; height: 220px; overflow: hidden; }
  .solution-image img, .post-image img { width: 100%; height: 100%; object-fit: cover; transition: 0.35s ease; }
  .solution-card:hover .solution-image img, .post-card:hover .post-image img { transform: scale(1.06); }
  .solution-image span, .post-image span {
    position: absolute;
    right: 16px;
    top: 16px;
    background: var(--accent);
    color: white;
    border-radius: 999px;
    padding: 8px 12px;
    font-weight: 900;
    font-size: 13px;
  }
  .solution-body, .post-body { padding: 24px; }
  .solution-logo { width: 88px; height: 58px; object-fit: contain; margin-bottom: 10px; }
  .solution-body h3, .service-card h3, .post-body h3 { color: var(--navy); font-size: 22px; margin: 0 0 12px; }
  .solution-body p, .service-card p, .post-body p { color: var(--muted); line-height: 1.75; margin: 0 0 18px; }

  .service-card { padding: 30px; }
  .service-icon {
    width: 62px;
    height: 62px;
    border-radius: 20px;
    display: grid;
    place-items: center;
    color: white;
    background:var(--primary);
    margin-bottom: 22px;
  }

  .section-action { width: min(1180px, 100%); margin: 28px auto 0; display: flex; justify-content: flex-end; }

  .contact-card {
    display: grid;
    grid-template-columns: 1.1fr 0.9fr;
    gap: 30px;
    border-radius: 34px;
    padding: 38px;
    color: white;
 background:
      radial-gradient(circle at 12% 18%, rgba(0,120,201,0.18), transparent 34%),
      radial-gradient(circle at 90% 24%, rgba(158,11,34,0.14), transparent 28%),
      linear-gradient(135deg, #061d34 0%, #082f56 52%, #04121f 100%);
    box-shadow: 0 24px 70px rgba(8,37,68,0.24);
  }
  .contact-card h3 { font-size: 30px; margin: 0 0 14px; color:#fff}
  .contact-card p { color: #fff; line-height: 1.8; margin: 0; }
  .contact-list { display: grid; gap: 18px; align-content: center; }
  .contact-list div { display: flex; gap: 12px; align-items: flex-start; color: #fff; line-height: 1.55; }
  .contact-list svg { color: #ffbac5; min-width: 22px; }
  .contact-list a { color: white; text-decoration: none; font-weight: 800; }
  .contact-list span { color: white; font-weight: 800;}

  .site-footer {
    padding: 70px 24px 24px;
     background:
      radial-gradient(circle at 12% 18%, rgba(0,120,201,0.18), transparent 34%),
      radial-gradient(circle at 90% 24%, rgba(158,11,34,0.14), transparent 28%),
      linear-gradient(135deg, #061d34 0%, #082f56 52%, #04121f 100%);
    color: #fff;
  }
  .footer-grid { display: grid; grid-template-columns: 1.4fr 0.8fr 1fr 0.8fr; gap: 38px; }
  .footer-logo { width: 210px; height: 70px; object-fit: contain; background: white; border-radius: 18px; padding: 8px 12px; margin-bottom: 18px; }
  .site-footer h4 { color: white; margin: 0 0 18px; }
  .site-footer a { display: flex; align-items: center; gap: 6px; color: rgba(255,255,255,0.72); text-decoration: none; margin-bottom: 12px; transition: 0.2s; }
  .site-footer a:hover { color: white; }
  .social-links { display: flex; gap: 10px; }
  .social-links a {
    width: 42px;
    height: 42px;
    border-radius: 999px;
    display: grid;
    place-items: center;
    background: rgba(255,255,255,0.08);
    color: white;
  }
  .copyright { width: min(1180px, 100%); margin: 40px auto 0; padding-top: 22px; border-top: 1px solid rgba(255,255,255,0.10); text-align: center; font-size: 14px; }

  @media (max-width: 980px) {
    .site-header { top: 0px; width: calc(100% - 20px); }
    .menu-btn { display: grid; place-items: center; }
    .nav-links {
      position: absolute;
      top: 86px;
      left: 0;
      right: 0;
      display: none;
      flex-direction: column;
      align-items: stretch;
      padding: 16px;
      border-radius: 22px;
      background: white;
      box-shadow: 0 20px 50px rgba(8,37,68,0.16);
    }
    .nav-links.open { display: flex; }
    .hero-content, .about-grid, .contact-card { grid-template-columns: 1fr; }
    .hero-section { padding-top: 130px; }
    .top-card { left: 14px; }
    .bottom-card { right: 14px; }
    .cards-grid.three, .cards-grid.four, .footer-grid { grid-template-columns: repeat(2, 1fr); }
  }

  @media (max-width: 640px) {
    .primary-btn.small { display: none; }
    .brand img { width: 128px; }
    .hero-copy h1 { letter-spacing: -1.5px; }
    .hero-visual img { min-height: 320px; border-radius: 24px; }
    .hero-card { position: static; margin-top: 12px; }
    .cards-grid.three, .cards-grid.four, .footer-grid { grid-template-columns: 1fr; }
    .about-panel, .contact-card { padding: 26px; border-radius: 24px; }
    .section-action { justify-content: stretch; }
    .section-action .outline-btn { width: 100%; }
  }
`;
